import { Route } from "@angular/router";
import { PasswordChangeComponent } from "./password-change.component";

export const PasswordChangeRouting: Route = {
    path: 'password-change',
    component: PasswordChangeComponent,
    data: {
        breadcrumb: "Changement de mot de passe"
    }
};
